function cov_1mkmmheqm8() {
  var path = "/app/src/utils/datadog/create-error-field-from-raw-error.ts";
  var hash = "7519556a746b6c88b8cb72c2638e2c5c036ee071";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/datadog/create-error-field-from-raw-error.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 29
        }
      },
      "1": {
        start: {
          line: 6,
          column: 17
        },
        end: {
          line: 6,
          column: 29
        }
      },
      "2": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 12,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "createErrorFieldFromRawError",
        decl: {
          start: {
            line: 3,
            column: 16
          },
          end: {
            line: 3,
            column: 44
          }
        },
        loc: {
          start: {
            line: 5,
            column: 16
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 6
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7519556a746b6c88b8cb72c2638e2c5c036ee071"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1mkmmheqm8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1mkmmheqm8();
export function createErrorFieldFromRawError(rawError) {
  cov_1mkmmheqm8().f[0]++;
  cov_1mkmmheqm8().s[0]++;
  if (!rawError) {
    cov_1mkmmheqm8().b[0][0]++;
    cov_1mkmmheqm8().s[1]++;
    return null;
  } else {
    cov_1mkmmheqm8().b[0][1]++;
  }
  cov_1mkmmheqm8().s[2]++;
  return {
    stack: rawError.stack,
    kind: rawError.type,
    message: rawError.message
  };
}